export const marketingCompaniesClientContext = {
  add: '/item-service/api/external/marketingCompanies',
  delete: '/item-service/api/external/marketingCompanies/{id}',
  getAll: '/item-service/api/external/marketingCompanies',
  update: '/item-service/api/external/marketingCompanies/{id}',
};
